import Image from "gatsby-image";
import React from "react";
import {PogorzanskiTygielSmakowImage} from "./PogorzanskiTygielSmakowImage";
import Opengraph from "../../../../assets/images/cases/pogorzanski-tygiel-smakow/og.png"

export const PogorzanskiTygielSmakowData = () => {
  const images = PogorzanskiTygielSmakowImage();
  return {
    color:          "#281B22",
    title:          "Pogórzański Tygiel Smaków",
    seo:
                    "Logo o smaku regionalnych potraw.",
    slug:           "pogorzanski-tygiel-smakow",
    opengraph:      Opengraph,
    hero:           {
      title:      "Logo o smaku regionalnych potraw.",
      color:      "#00609A",
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"cover"}
                      fluid={images.hero.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.detail.childImageSharp.fluid}
                    />
                  ),
    },
    what_we_did:    {
      title:        "Tradycyjne smaki w nowej odsłonie",
      technologies: [
        "Identyfikacja wizualna",
        "Social media",
        "Kampania reklamowa",
        "Zdjęcia produktowe",
      ],
      text:
                    "Pogórzański Tygiel Smaków to szlak kulinarny, którego celem jest promocja lokalnych zasobów dziedzictwa kulturowego Podkarpacia. Ponieważ zawsze chętnie angażujemy się w regionalne inicjatywny, również tym razem postanowiliśmy wesprzeć budowanie rozpoznawalności szlaku. Zrobiliśmy ten pierwszy, najważniejszy krok, czyli... logo! Nasz projekt nawiązuje do stempla. Dlaczego? Pod każdą z atrakcji znajdującej się na szlaku kulinarnym można przybić pieczątkę, a tym samym dać gwarancję smaku i jakości regionalnych potraw.",
      image:        (
                      <Image
                        alt=""
                        objectPosition={"center"}
                        objectFit={"contain"}
                        fluid={images.what_we_did_detail.childImageSharp.fluid}
                      />
                    ),
      imageWidth:   563,
    },
    list:           {
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_bg.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_detail.childImageSharp.fluid}
                    />
                  ),
    },
    column_images:  {
      first: {
        img1: {
          image: (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.column_1.childImageSharp.fluid}
                   />

                 ),
          width: 480,
        },
        img2: {
          image: (
                   (
                     <Image
                       alt=""
                       objectPosition={"center"}
                       objectFit={"contain"}
                       fluid={images.column_2.childImageSharp.fluid}
                     />
                   )
                 ),
          width: 374,
        }
      },
    },
    full_images:    {
      first:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_1.childImageSharp.fluid}
                 />
               ),
      },
      second: {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_2.childImageSharp.fluid}
                 />
               ),
      },
      third:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_3.childImageSharp.fluid}
                 />
               ),
      },
      fourth: {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_4.childImageSharp.fluid}
                 />
               ),
      },
      fifth:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_5.childImageSharp.fluid}
                 />
               ),
      },
    },
    headers:        {
      first:  "Szczegółowa księga znaku",
      second: "Dedykowany landing page",
    },
    text_boxes:     {
      first:  {
        title: "Kulinarne symbole w połączeniu z naturą",
        text:  "Styl użytych fontów wpasowuje się w ludowy klimat. Nad ilustracją szlaku umieszczono najbardziej rozpoznawalne akcesoria kuchenne, które nawiązują do przepysznych pogórzańskich potraw. Logo powstało w oparciu o dwa kolory: niebieski - symbolizujący obszar rzeki San - oraz zielony - symbolizujący naturalne otoczenie.",
      },
      second: {
        title: "Funkcjonalność nade wszystko",
        text:
               "Zaprojektowane przez nas logo - oprócz tego, że wpisuje się w ideę całego szlaku - jest przede wszystkim użyteczne. Bez problemu można je wykorzystać na wielu formatach zarówno w internecie, jak i poza nim, a ono nie straci na jakości i nadal będzie czytelne. ",
      },
    },
    content_images: {
      first:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_1.childImageSharp.fluid}
                />
              ),
      second: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_2.childImageSharp.fluid}
                />
              ),
      third:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_3.childImageSharp.fluid}
                />
              )
    },
  };
};
